import { useState } from "react";
import axios from "axios";
import config from "../../config";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { Select, Space, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const oneYearFromNow = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d;
};

const AddUser = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        lastname: "",
        password: "",
        username: "",
        role: 0,
        personalId: "",
        kind: 1,
        signupDatetime: new Date(),
        expirationDatetime: oneYearFromNow(),
        systemNumber: ""
    });
    const [neverExpire, setNeverExpire] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [showEtcField, setShowEtcField] = useState(false);

    const handleChange = (e) => {

        setFormData({ ...formData, [e.target.name]: e.target.value });
        setFormData({
            ...formData,
            [e.target.name]: e.target.name === "role" ? parseInt(e.target.value) : e.target.value,
        });
    };
    const handleDateChange = (date) => {
        setFormData((prev) => ({
            ...prev,
            signupDatetime: date?.toDate?.() || new Date()
        }));
    };
    const handleExpirationDateChange = (date) => {
        setFormData((prev) => ({
            ...prev,
            expirationDatetime: date?.toDate?.() || oneYearFromNow()
        }));
    };
    const handleRole = (e) => {
        setFormData({
            ...formData,
            ["role"]: e
        });
        if (e === 1) {
            setShowEtcField(true);
        } else if (e === 0) {
            setShowEtcField(false);
        }
    }
    const handleKind = (e) => {
        setFormData({ ...formData, ["kind"]: e });
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (formData.kind === 0) {
                toast.error(<p dir="rtl" className="font-custom">لطفا نوع کاربر را به درستی مشخص کنید</p>, { autoClose: 3000 });
                return;
            }
            setIsLoading(true);
            const payload = {
                ...formData,
                expirationDatetime: neverExpire ? null : formData.expirationDatetime,
            };
            const response = await axios.post(`${config.apiBaseUrl}/api/users/createuser`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "HeaderKey": config.HeaderKey
                },
                withCredentials: true,
            });
            toast.success(<p dir="rtl" className="font-custom">کاربر با موفقیت ساخته شد!</p>, { autoClose: 3000 });

            setTimeout(() => {
                if (formData.role == 0) {
                    navigate("/dashboard/users");
                } else {
                    navigate("/dashboard/students");
                };
            }, 500);
            setFormData({ name: "", email: "", lastname: "", password: "", username: "", role: 0 });

        } catch (error) {
            if (error.status === 409) {
                toast.error(<p dir="rtl" className="font-custom">نام کاربری وارد شده از قبل در سیستم وجود دارد!</p>, { autoClose: 3000 });
            } else {
                toast.error("خطا در ساخت کاربر!", { autoClose: 3000 });
            }
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="max-w-md font-custom mx-auto bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-l text-center font-semibold text-gray-700 mb-4">اضافه کردن کاربر</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="flex gap-2">
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام خانوادگی</label>
                            <input
                                type="text"
                                name="lastname"
                                dir="rtl"
                                onInvalid={(e) => { e.target.setCustomValidity("لطفاً نام خانوادگی کاربر را وارد کنید"); }}
                                onInput={(e) => e.target.setCustomValidity("")}
                                value={formData.lastname}
                                onChange={handleChange}
                                className="w-full text-right p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام</label>
                            <input
                                type="text"
                                name="name"
                                dir="rtl"
                                value={formData.name}
                                onInvalid={(e) => { e.target.setCustomValidity("لطفاً نام کاربر را وارد کنید"); }}
                                onInput={(e) => e.target.setCustomValidity("")}
                                onChange={handleChange}
                                className="w-full text-right p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="personalId" className="text-sm text-gray-600 mb-1">:کد ملی</label>
                            <input
                                type="text"
                                name="personalId"
                                value={formData.personalId}
                                onInvalid={(e) => { e.target.setCustomValidity("لطفاً کد ملی را وارد کنید"); }}
                                onInput={(e) => e.target.setCustomValidity("")}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label htmlFor="phoneNumber" className="text-sm text-gray-600 mb-1">:شماره تلفن</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                onInvalid={(e) => e.target.setCustomValidity("لطفاً شماره تلفن را وارد کنید")}
                                onInput={(e) => e.target.setCustomValidity("")}
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="email" className="text-sm text-gray-600 mb-1">:ایمیل</label>
                        <input
                            type="email"
                            name="email"
                            onInvalid={(e) => { e.target.setCustomValidity("لطفاً ایمیل را وارد کنید"); }}
                            onInput={(e) => e.target.setCustomValidity("")}
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="username" className="text-sm text-gray-600 mb-1">:نام کاربری</label>
                        <input
                            type="text"
                            name="username"
                            placeholder="Username"
                            onInvalid={(e) => { e.target.setCustomValidity("لطفاً نام کاربری را وارد کنید"); }}
                            onInput={(e) => e.target.setCustomValidity("")}
                            value={formData.username}
                            onChange={handleChange}
                            className="w-full p-2  border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="password" className="text-sm text-gray-600 mb-1">:رمز عبور</label>
                        <Space direction="vertical">
                            <Input.Password
                                className="w-full p-2 border font-custom border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Password"
                                iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            />
                        </Space>
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="role" className="text-sm text-gray-600 mb-1">:نوع</label>
                        <div className="relative">
                            <Select
                                name="role"
                                value={(formData.kind)}
                                onChange={e => handleKind(e)}
                                className="w-full text-right font-custom"
                                placeholder="نوع کاربر"
                                options={[
                                    { value: 0, className: "font-custom text-right", label: "نامشخص", disabled: true },
                                    { value: 1, className: "font-custom text-right", label: "پزشکی" },
                                    { value: 2, className: "font-custom text-right", label: "دندانپزشکی" },
                                    { value: 3, className: "font-custom text-right", label: "آپارات" },
                                    { value: 4, className: "font-custom text-right", label: "ادمین کل", disabled: true },
                                ]}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full text-right">
                        <label htmlFor="role" className="text-sm text-gray-600 mb-1">:نقش</label>
                        <div className="relative">
                            <Select
                                name="role"
                                value={(formData.role)}
                                onChange={e => handleRole(e)}
                                className="w-full text-right font-custom"
                                placeholder="انتخاب نقش"
                                options={[
                                    { value: 0, className: "font-custom text-right", label: "ادمین" },
                                    { value: 1, className: "font-custom text-right", label: "دانشجو" },
                                ]}
                            />
                        </div>
                    </div>

                    {(showEtcField &&
                        <div className="flex gap-2">
                            
                            <div className="flex flex-col w-1/2 text-right">
                                <label htmlFor="phoneNumber" className="text-sm text-gray-600 mb-1">:شماره نظام</label>
                                <input
                                    type="text"
                                    name="systemNumber"
                                    value={formData.systemNumber}
                                    onChange={handleChange}
                                    onInvalid={(e) => e.target.setCustomValidity("لطفاً شماره نظام را وارد کنید")}
                                    onInput={(e) => e.target.setCustomValidity("")}
                                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>
                            <div className="flex flex-col w-1/2 text-right">
                                <label htmlFor="signupDatetime" className="text-sm text-gray-600 mb-1">: تاریخ ثبت نام</label>

                                <div className="flex flex-col w-full text-right">
                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        value={formData.signupDatetime}
                                        onChange={handleDateChange}
                                        calendarPosition="bottom-right"
                                        name="signupDatetime"
                                    />
                                </div>
                            </div>
                        </div>

                    )}
                    {(showEtcField &&
                        <div className="flex flex-col w-full text-right gap-2">
                            <label htmlFor="expirationDatetime" className="text-sm text-gray-600 mb-1">:تاریخ انقضا</label>
                            <div className="flex flex-wrap items-center gap-3 justify-end">
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={neverExpire ? null : formData.expirationDatetime}
                                    onChange={handleExpirationDateChange}
                                    calendarPosition="bottom-right"
                                    name="expirationDatetime"
                                    disabled={neverExpire}
                                />
                                <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={neverExpire}
                                        onChange={(e) => setNeverExpire(e.target.checked)}
                                    />
                                    بدون انقضا
                                </label>
                            </div>
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full flex justify-center items-center gap-2 bg-blue-500 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isLoading ? <FaSpinner className="animate-spin" /> : "اضافه کردن"}
                    </button>
                </form>
            </div>

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                className={"font-custom text-center rtl"}
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
        </div>

    );
};

export default AddUser;